// @module C3.PDPSerialLotFunctionality.SerialLotData
define('C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems'
,	[
	'tekyard_pdpseriallotfunctionality_seriallotdata_carouselitems.tpl'
    ,   'C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems.Model'
    ,   'C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems.Skeleton'
    ,   'C3.PDPSerialLotFunctionality.SerialLotData.Carousel.ItemsList'
    ,   'C3.PDPSerialLotFunctionality.SerialLotData.InfoTooltip'
	,	'Backbone'
	,   'Backbone.View'
	,   'C3.Available.View'
    ]
, function (
	tekyard_pdpseriallotfunctionality_seriallotdata_carouselitems_tpl
	,   SerialLotCarouselItemsModel
	,   PopupSkeletonView
	,   CarouselView
	,   InfoTooltip
	,	Backbone
	,   BackboneView
	,   AvailableView
)
{
    'use strict';

	// @class C3.PDPSerialLotFunctionality.SerialLotData.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_seriallotdata_carouselitems_tpl

	,	initialize: function (options) {	
			this.options = options;	
			this.item = options.item;	
			this.functional = options.functional;
			this.cosmetic = options.cosmetic;
			this.functionalname = options.functionalname;
			this.cosmeticname = options.cosmeticname;
			this.application = options.application;
			this.layout = options.layout;
			this.functionalConditions = options.functionalConditions;
			this.cosmeticConditions = options.cosmeticConditions;
			this.filteredInventory = options.filteredInventory;
			this.parentView = options.parentView;
			this.model = new SerialLotCarouselItemsModel();

			this.loading = true;
		    this.skeletonView = null;

		    this.on('afterCompositeViewRender', this.setQtyField, this);
		    // Init info-icon tooltips (Functional / Cosmetic dropdowns) on every render.
		    this.on('afterCompositeViewRender', function () {
		        InfoTooltip.initInfoTooltips(this.$el);
		    }, this);
			var invtItems = this.model.get('inventoryrecords')
			var elmt = $('[data-view="Avialable-Items-Count"]')
			var AVView = new AvailableView({
                items : invtItems
            });
            AVView.render();
            elmt.empty().append(AVView.$el);
		}

	,   updateCondition: function updateCondition(e) {
		    var targetElement = $(e.currentTarget);
		    var conditionType = targetElement.attr('name'); // "cosmetic" or "functional"
		    var value = targetElement.val();
		    //console.log(value)
		    // Update local state
		    if (conditionType === 'cosmetic') {
		        this.cosmetic = value;
		    } else if (conditionType === 'functional') {
		        this.functional = value;
		    }

		    // Update URL
		        this.updateUrl(conditionType, value);

		    // Clear extra view container so it won’t show stale content
    		this.parentView.$('[data-view="SerialLot.Popup.PD"]').empty();

		    // Trigger skeleton + fetch again
		    this.loading = true;
		    this.render();
		}

	,   updateUrl: function updateUrl(name, value) {
	    var url = window.location.href;

	    if (url.indexOf('#') > -1) {
	        // -------- Local (hash based) --------
	        var parts = url.split('#');
	        var base = parts[0];
	        var hash = parts[1] || '';

	        var route = hash.split('?')[0] || '';
	        var params = new URLSearchParams(hash.split('?')[1] || '');

	        // update/set param
	        params.set(name, value);

	        var newHash = route + '?' + params.toString();
	        var newUrl = base + '#' + newHash;

	        window.history.replaceState({}, '', newUrl);
	    } else {
	        // -------- Live (normal URL params) --------
	        var liveUrl = new URL(url);
	        liveUrl.searchParams.set(name, value);
	        window.history.replaceState({}, '', liveUrl.toString());
	    }
	}	
		

	,   render: function () {
	      if (this.loading) {
	        BackboneView.prototype.render.apply(this, arguments);

	        var self = this;
	        this.model.fetch({
	          data: {
	            itemid: self.item && self.item.internalid,
	            functional: self.functional,
	            cosmetic: self.cosmetic
	        	}
	        }).then(function () {
	          self.loading = false;
	          self.render(); // swap skeleton → data view
	        });
	      } else {
	        BackboneView.prototype.render.apply(this, arguments);
	      }
	    }	

	,	events: {
			'change [data-action="changeCondition"]': 'updateCondition'
		}

	,	bindings: {
		}

	, 	childViews: {
		  'Serial.Carousel': function () {
	    	if (this.loading) {
	          if (!this.skeletonView) {
	            this.skeletonView = new PopupSkeletonView();
	          }
	          return this.skeletonView;
	        } else {
	          // Always recreate data view so it reflects latest model & conditions
				
				const functionalname = this.functionalConditions.find(item => item.id === this.functional);
				const cosmeticname = this.cosmeticConditions.find(item => item.id === this.cosmetic);
				
				var dataView = new CarouselView({
				    cosmeticname : cosmeticname,
				    functionalname : functionalname,
				    cosmetic: this.cosmetic,
				    functional: this.functional,
				    layout: this.layout,
				    model: this.model,   // new fetch results
				    application: this.application,
				    item: this.item 
				});

				// clear skeleton after data load
				if (this.skeletonView) {
				    this.skeletonView = null;
				}

				return dataView;

	        }
		  }
		}

		//@method getContext @return Tekyard.PDPSerialLotFunctionality.SerialLotData.View.Context
	,	getContext: function getContext() {
		    const selectedFunctional = this.functional;
		    const selectedCosmetic = this.cosmetic;

		    var viewFunctionalConditions = _.map(this.functionalConditions || [], function(item) {
			    return _.extend({}, item, {
			        'default': item.id.toString() === selectedFunctional.toString()
			    });
			});

			var viewCosmeticConditions = _.map(this.cosmeticConditions || [], function(item) {
			    return _.extend({}, item, {
			        'default': item.id.toString() === selectedCosmetic.toString()
			    });
			});

			// Labels of the currently-selected conditions, exposed so the template can
			// stamp them onto the info icons as `data-current-label` for the tooltip lookup.
			var currentFunctionalItem = _.find(viewFunctionalConditions, function (c) { return c['default']; });
			var currentCosmeticItem   = _.find(viewCosmeticConditions,   function (c) { return c['default']; });

			//console.log(viewFunctionalConditions)
		    return {
		        functionalConditions : viewFunctionalConditions,
		        cosmeticConditions: viewCosmeticConditions,
		        currentFunctionalCondition: currentFunctionalItem ? currentFunctionalItem.label : '',
		        currentCosmeticCondition:   currentCosmeticItem   ? currentCosmeticItem.label   : ''
		    };
		}

	});
});
